import { css } from '@emotion/react'
import { HFlow, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { useFatoresRiscoPreEclampsiaModal } from 'hooks/sdc/useFatoresRiscoPreEclampsiaModal'
import { ReactComponent as SdcIcon } from 'images/suporte-decisao-clinica/health-system-outline.svg'
import { dateAsDdMmYyyy } from 'util/date/formatDate'

import { RiscoPreEclampsiaTag } from './RiscoPreEclampsiaTag'
import { SdcFatoresRiscoPreEclampsiaModal } from './SdcFatoresRiscoPreEclampsiaModal'

export function SdcRiscoPreEclampsiaSection() {
  //TODO@Codebenders: usar valor retornado pelo DB após conclusão da issue #26441
  const ultimaAtualizacao = dateAsDdMmYyyy(new Date())
  const theme = useTheme()
  const styles = createStyles(theme)

  const {
    isModalFatoresRiscoPreEclampsiaOpen,
    openModalFatoresRiscoPreEclampsia,
    closeModalFatoresRiscoPreEclampsia,
  } = useFatoresRiscoPreEclampsiaModal()

  return (
    <VFlow vSpacing={0.75}>
      <VFlow vSpacing={0.5}>
        <HFlow alignItems='center' justifyContent='space-between'>
          <HFlow hSpacing={0.5} alignItems='center' justifyContent='flex-start'>
            <SdcIcon />
            <Text component='h4' variant='h4' fontWeight='bold'>
              Suporte à Decisão Clínica
            </Text>
          </HFlow>
          <Text component='h5' variant='h5' fontWeight='normal' fontStyle='italic' style={styles.lastUpdate}>
            Risco atualizado pelo SDC em {ultimaAtualizacao}
          </Text>
        </HFlow>
        <Text component='h5' variant='h5' fontWeight='normal'>
          O SDC identifica riscos com base nos dados do prontuário. Para uma avaliação precisa, verifique se os fatores
          de risco estão registrados.
        </Text>
      </VFlow>
      <VFlow vSpacing={0.25}>
        <VFlow vSpacing={0.5}>
          <Text component='h5' variant='h5' fontWeight='bold'>
            Risco de pré-eclâmpsia:
          </Text>
          <RiscoPreEclampsiaTag dataTestId='SdcRiscoPreEclampsiaSection.riscoPreEclampsiaTag' />
        </VFlow>
        <Text
          color='primary'
          fontWeight='normal'
          textDecoration='underline'
          style={styles.pointer}
          onClick={openModalFatoresRiscoPreEclampsia}
        >
          Ver fatores analisados
        </Text>
        <SdcFatoresRiscoPreEclampsiaModal
          modalOpen={isModalFatoresRiscoPreEclampsiaOpen}
          setModalOpen={closeModalFatoresRiscoPreEclampsia}
        />
      </VFlow>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  lastUpdate: css`
    color: ${theme.pallete.gray.c40};
  `,
  pointer: css`
    cursor: pointer;
  `,
})
